<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xx0cWW/tc-custom/9781504072410.jpg?1703867466923" alt="This image is the cover for the book Twelve Days"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Twelve Days
      </h1>
      <p class="bookDescription body article font2">
        <b>Ten people. Twelve days. One killer. Cult members come together for what might be their last time—alive—in this gripping, claustrophobic crime thriller.</b><br/><br/>Ten people meet for a reunion at a remote castle, organised by a preacher who once held them in a Christian cult. One by one, the old friends are brutally murdered, and yet their killer remains hidden in their very midst.<br/><br/>Rafe attends the reunion at the castle for one reason only: to settle once and for all how he really feels about his childhood obsession, Suzanne. Rivalry reignites at the outset as the men who all loved and fought over Suzanne are brought together once more.<br/><br/>Is Suzanne the reason for these serial killings?<br/><br/>Is the murderer a jealous lover?<br/><br/>Or is she the femme fatale with a bloody agenda?<br/><br/>As tension mounts, Rafe must play this deadly game in order to identify and neutralise the hidden serial killer before he himself becomes the next victim . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Williams
      </h2>
      
      <p class="authorDescription body article">Paul Williams was born in the UK but grew up in Africa where he spent two years in a civil war as a frontline medic. Surviving that, he has been a radio DJ in Zimbabwe, a surfer in Durban, South Africa, and a lead guitarist in a rock band in the Middle East. He has a PhD from the USA and is currently the Programme Leader of Creative Writing at the University of the Sunshine Coast in Queensland, Australia.   His memoir about the war, Soldier Blue (New Africa Books 2007), won Book of the Year in South Africa in 2008, and since then he has published internationally across several genres.   He lives near the beach with his family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4aa0d876